import {observer} from "mobx-react";
import React, {useContext} from "react";
import OrderSettingsPageStoreContext from "../context";
import {Button, FormControl, Paper, Typography} from "../../../../../common/components/libs";
import {FormControlLabel, InputLabel, Radio, RadioGroup, Switch} from "@material-ui/core";
import {changeCheckboxEventHandlerDecorator, changeEventHandlerDecorator, localize} from "../../../../../common/libs";
import {
    DeliveryConditionType,
    DeliveryType,
    IDeliveryConditionsFixedPrice,
    IDeliveryConditionsZonePrice
} from "../../../../../services/menu/models";
import Input from "@material-ui/core/Input";
import {useTranslation} from "react-i18next";
import style from "./../style.module.css";
import {useStores} from "../../../../../hooks";


const DeliveryTypesBlock = () => {
    const { t } = useTranslation(["general", "menu"]);
    const store = useContext(OrderSettingsPageStoreContext);
    const {generalStore, authStore} = useStores()
    const { hasIIkoIntegration } = store;
    const deliveryConditions = store.deliverySettings[DeliveryType.toAddress].deliveryConditions

    const openDeliveryConditionsForm = () => {
        store.openUpdateDeliveryConditionsForm()
    };

    const openDeliveryZoneForm = () => {
        store.openDeliveryZonesForm()
    };



    return <>
        <Typography variant={"h3"} mt={20} mb={2}>
            {t("menu:orderSettingsPage.orderMethods")}
        </Typography>

        <Paper p={5}>
			<Typography variant="h6" mt={0}>
                {t("menu:orderSettingsPage.inRestaurantWithoutChoosingTable")}
			</Typography>
			<Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:orderSettingsPage.suitableToBar")}
			</Typography>
			<FormControl>
				<FormControlLabel
					control={
                        <Switch
                            checked={store.deliverySettings[DeliveryType.insideTheRestaurant].isEnabled && authStore.isBasicFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isBasicFeaturesActive()) {
                                        store.openTariffPromptForm('Basic')
                                    } else {
                                        store.setDeliveryInsideTheRestaurantSettings({
                                            description: localize(store.deliverySettings[DeliveryType.insideTheRestaurant].description),
                                            isEnabled: v
                                        })
                                    }
                                }
                            )}
                            value={store.deliverySettings[DeliveryType.insideTheRestaurant].isEnabled}
                        />
                    }
					label={t("general:include")}
				/>
			</FormControl>
			<FormControl fullWidth>
				<InputLabel htmlFor="name">{t("general:description")}</InputLabel>
				<Input
					value={localize(store.deliverySettings[DeliveryType.insideTheRestaurant].description)}
					onChange={changeEventHandlerDecorator(
                        (v: string) => {
                            store.setDeliveryInsideTheRestaurantSettings({
                                description: v,
                                isEnabled: store.deliverySettings[DeliveryType.insideTheRestaurant].isEnabled
                            })
                        })}
				/>
			</FormControl>
		</Paper>
        <Paper p={5} style={{ maxWidth: 800, width: "100%" }} mt={5}>
            <Typography variant="h6" mt={0}>
                {t("menu:orderSettingsPage.insideRestaurant")}
            </Typography>
            <Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:orderSettingsPage.suitableToTable")}
            </Typography>
            <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.deliverySettings[DeliveryType.toTable].isEnabled && authStore.isBasicFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isBasicFeaturesActive()) {
                                        store.openTariffPromptForm('Basic')
                                    } else {
                                        const settings = store.deliverySettings[DeliveryType.toTable];
                                        store.setDeliveryToTableSettings({
                                            ...settings,
                                            description: localize(settings.description),
                                            isEnabled: v,
                                        })
                                    }
                                }
                            )}
                            value={store.deliverySettings[DeliveryType.toTable].isEnabled}
                        />
                    }
                    label={t("general:include")}
                />
            </FormControl>
            {store.deliverySettings[DeliveryType.toTable].isEnabled && <FormControl>
				<FormControlLabel
					control={
                        <Switch
                            checked={!store.deliverySettings[DeliveryType.toTable].isChangeTableEnabled && authStore.isBasicFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isBasicFeaturesActive()) {
                                        store.openTariffPromptForm('Basic')
                                    } else {
                                        const settings = store.deliverySettings[DeliveryType.toTable];

                                        store.setDeliveryToTableSettings({
                                            ...settings,
                                            description: localize(settings.description),
                                            isChangeTableEnabled: !v,
                                        })
                                    }
                                }
                            )}
                            value={!store.deliverySettings[DeliveryType.toTable].isChangeTableEnabled}
                        />
                    }
					label={t("menu:orderSettingsPage.isChangeTableEnabled.title")}
				/>
			</FormControl>}
            <FormControl fullWidth>
                <InputLabel htmlFor="name">{t("general:description")}</InputLabel>
                <Input
                    value={localize(store.deliverySettings[DeliveryType.toTable].description)}
                    onChange={changeEventHandlerDecorator(
                        (v: string) => {
                            const settings = store.deliverySettings[DeliveryType.toTable];
                            store.setDeliveryToTableSettings({
                                ...settings,
                                description: v,
                            })
                        }
                    )}
                    disabled={!store.deliverySettings[DeliveryType.toTable].isEnabled}
                />
            </FormControl>

        </Paper>
        <Paper p={5} style={{ maxWidth: 800, width: "100%" }} mt={5}>
            <Typography variant="h6" mt={0}>
                {t("menu:orderSettingsPage.takeaway")}
            </Typography>
            <Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:orderSettingsPage.suitableToTakeaway")}
            </Typography>
            <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.deliverySettings[DeliveryType.takeaway].isEnabled && authStore.isBasicFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isBasicFeaturesActive()) {
                                        store.openTariffPromptForm('Basic')
                                    } else {
                                        store.setDeliveryTakeawaySettings({
                                            description: localize(store.deliverySettings[DeliveryType.takeaway].description),
                                            isEnabled: v,
                                        })
                                    }
                                }
                            )}
                            value={store.deliverySettings[DeliveryType.takeaway].isEnabled}
                        />
                    }
                    label={t("general:include")}
                />
            </FormControl>
            <FormControl fullWidth>
                <InputLabel htmlFor="name">{t("general:description")}</InputLabel>
                <Input
                    value={localize(store.deliverySettings[DeliveryType.takeaway].description)}
                    onChange={changeEventHandlerDecorator(
                        (v: string) => {
                            store.setDeliveryTakeawaySettings({
                                description: v,
                                isEnabled: store.deliverySettings[DeliveryType.takeaway].isEnabled,
                            })
                        }
                    )}
                    disabled={!store.deliverySettings[DeliveryType.takeaway].isEnabled}
                />
            </FormControl>
        </Paper>

        <Paper p={5} style={{ maxWidth: 800, width: "100%" }} mt={5}>
            <Typography variant="h6" mt={0}>
               {t("menu:orderSettingsPage.takeawayToTime")}
            </Typography>
            <Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:orderSettingsPage.suitableToTakeawayToTime")}
            </Typography>
            <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.deliverySettings[DeliveryType.takeAwayToTime].isEnabled && authStore.isBasicFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isBasicFeaturesActive()) {
                                        store.openTariffPromptForm('Basic')
                                    } else {
                                        store.setDeliveryTakeawayToTimeSettings({
                                            description: localize(store.deliverySettings[DeliveryType.takeAwayToTime].description),
                                            isEnabled: v,
                                            isDateRequired: false,
                                        })
                                    }
                                }
                            )}
                            value={store.deliverySettings[DeliveryType.takeAwayToTime].isEnabled}
                        />
                    }
                    label={t("general:include")}
                />
            </FormControl>
            {store.deliverySettings[DeliveryType.takeAwayToTime].isEnabled && <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.deliverySettings[DeliveryType.takeAwayToTime].isDateRequired}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    const settings = store.deliverySettings[DeliveryType.takeAwayToTime];

                                    store.setDeliveryTakeawayToTimeSettings({
                                        ...settings,
                                        description: localize(settings.description),
                                        isDateRequired: v,
                                    })
                                }
                            )}
                            value={store.deliverySettings[DeliveryType.takeAwayToTime].isDateRequired}
                        />
                    }
                    label={t("menu:orderSettingsPage.isDateRequired.title")}
                />
            </FormControl>}
            <FormControl fullWidth>
                <InputLabel htmlFor="name">{t("general:description")}</InputLabel>
                <Input
                    value={localize(store.deliverySettings[DeliveryType.takeAwayToTime].description)}
                    onChange={changeEventHandlerDecorator(
                        (v: string) => {
                            store.setDeliveryTakeawayToTimeSettings({
                                description: v,
                                isEnabled: store.deliverySettings[DeliveryType.takeAwayToTime].isEnabled,
                                isDateRequired: store.deliverySettings[DeliveryType.takeAwayToTime].isDateRequired,
                            })
                        }
                    )}
                    disabled={!store.deliverySettings[DeliveryType.takeAwayToTime].isEnabled}
                />
            </FormControl>
        </Paper>

        {<Paper p={5} style={{ maxWidth: 800, width: "100%" }} mt={5}>
			<Typography variant="h6" mt={0}>
                {t("menu:orderSettingsPage.delivery")}
			</Typography>
			<Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:orderSettingsPage.suitableToHome")}
			</Typography>
			<FormControl>
				<FormControlLabel
					control={
                        <Switch
                            checked={store.deliverySettings[DeliveryType.toAddress].isEnabled && authStore.isBasicFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isBasicFeaturesActive()) {
                                        store.openTariffPromptForm('Basic')
                                    } else {
                                        store.setDeliveryToAddressSettings({
                                            description: localize(store.deliverySettings[DeliveryType.toAddress].description),
                                            isEnabled: v,
                                            deliveryConditions: store.deliverySettings[DeliveryType.toAddress].deliveryConditions
                                        })
                                    }
                                }
                            )}
                            value={store.deliverySettings[DeliveryType.toAddress].isEnabled}
                        />
                    }
					label={t("general:include")}
				/>
			</FormControl>
            <FormControl fullWidth>
                <InputLabel htmlFor="name">{t("general:description")}</InputLabel>
                <Input
                    value={localize(store.deliverySettings[DeliveryType.toAddress].description)}
                    onChange={changeEventHandlerDecorator(
                        (v: string) => {
                            store.setDeliveryToAddressSettings({
                                description: v,
                                isEnabled: store.deliverySettings[DeliveryType.toAddress].isEnabled,
                                deliveryConditions: store.deliverySettings[DeliveryType.toAddress].deliveryConditions
                            })
                        }
                    )}
                    disabled={!store.deliverySettings[DeliveryType.toAddress].isEnabled}
                />
            </FormControl>
            {store.deliverySettings[DeliveryType.toAddress].isEnabled &&
                <FormControl style={{width: "100%"}}>
                    <RadioGroup value={store.deliverySettings[DeliveryType.toAddress].deliveryConditions}>

                        <div className={[style.deliveryConditions, deliveryConditions.type === DeliveryConditionType.fixedPrice ? style.selected : undefined].join(" ")}>
                            <FormControlLabel
                                checked={deliveryConditions.type === DeliveryConditionType.fixedPrice}
                                key={DeliveryConditionType.fixedPrice}
                                disabled={!authStore.isBasicFeaturesActive()}
                                control={<Radio/>}
                                label={
                                <div className={style.deliveryLabel}>
                                    <svg width="34" height="31" viewBox="0 0 34 31" xmlns="http://www.w3.org/2000/svg" className={style.svg}>
                                        <path d="M29.3286 2.51728C29.3269 1.12675 28.1994 0 26.8086 0H16.2564C15.5881 0 14.9471 0.265425 14.4745 0.73799L0.738384 14.4712C-0.246049 15.4554 -0.246128 17.0513 0.738148 18.0357L11.2903 28.588C11.7824 29.0801 12.4275 29.3262 13.0725 29.3262C13.4785 29.3262 13.8801 29.2172 14.248 29.0222C15.5944 27.9134 13.6024 29.8399 28.5906 14.8548C29.0634 14.3821 29.3289 13.741 29.3289 13.0724C29.3289 2.36882 29.329 4.19725 29.3286 2.51728ZM28.0688 13.0724C28.0688 13.409 27.9376 13.7255 27.6996 13.9635L13.9635 27.697C13.7254 27.935 13.409 28.0661 13.0724 28.0661C12.7357 28.0661 12.4193 27.9349 12.1813 27.697L1.62925 17.1447C1.39123 16.9067 1.26018 16.5901 1.26018 16.2536C1.26018 15.917 1.39131 15.6005 1.62933 15.3625L15.3654 1.62917C15.6034 1.39123 15.9198 1.26018 16.2564 1.26018H26.8087C27.5035 1.26018 28.0688 1.82552 28.0688 2.52035V13.0724H28.0688Z" className={style.svg}/>
                                        <path d="M31.8491 2.51953V14.3316C31.8491 14.6683 31.7179 14.9848 31.4799 15.2228L16.5918 30.1082L17.4828 30.9993L32.3709 16.114C32.8437 15.6413 33.1092 15.0002 33.1092 14.3316V2.51953H31.8491Z" />
                                        <path d="M22.3978 4.40918C21.0084 4.40918 19.8774 5.53948 19.8774 6.92953C19.8774 8.31958 21.0084 9.44988 22.3978 9.44988C23.7872 9.44988 24.9181 8.31958 24.9181 6.92953C24.9181 5.53948 23.7871 4.40918 22.3978 4.40918ZM22.3978 8.18971C21.7025 8.18971 21.1376 7.6242 21.1376 6.92953C21.1376 6.23486 21.7025 5.66936 22.3978 5.66936C23.0931 5.66936 23.658 6.23486 23.658 6.92953C23.658 7.6242 23.0931 8.18971 22.3978 8.18971Z" />
                                    </svg>

                                    <div>
                                        <p className={style.deliveryType}>{t("menu:fixed")}</p>
                                        <p className={style.deliveryTypeDescription}>{t("menu:theSame")}</p>
                                    </div>
                                </div>
                            }
                                onChange={() => {
                                    const data: IDeliveryConditionsFixedPrice = {
                                        type: DeliveryConditionType.fixedPrice,
                                        fixedDeliveryPrice: {
                                            currencyId: generalStore.currency.id,
                                            price: (deliveryConditions.type === DeliveryConditionType.fixedPrice && deliveryConditions.fixedDeliveryPrice) ?
                                             deliveryConditions.fixedDeliveryPrice.price : 0
                                        },
                                        freeDeliveryMinimalOrderPrice: {
                                            currencyId: generalStore.currency.id,
                                            price: (deliveryConditions.type === DeliveryConditionType.fixedPrice && deliveryConditions.freeDeliveryMinimalOrderPrice) ?
                                                deliveryConditions.freeDeliveryMinimalOrderPrice.price : 0
                                        },
                                    };
                                    store.setDeliveryToAddressSettings({
                                    description: localize(store.deliverySettings[DeliveryType.toAddress].description),
                                    deliveryConditions: data,
                                    isEnabled: store.deliverySettings[DeliveryType.toAddress].isEnabled,
                                })
                                }}
                            />

                            {
                                (deliveryConditions && deliveryConditions.type === DeliveryConditionType.fixedPrice) &&
                                <>
                                    <div className={style.change}>
                                        <p>{t("general:settings")}:</p>
                                        <Button
                                            disabled={!authStore.isBasicFeaturesActive()}
                                            onClick={openDeliveryConditionsForm}
                                            color="primary"
                                            m={0}
                                            p={0}
                                        >
                                            {t("general:change")}
                                        </Button>
                                    </div>
                                    <span>{t("menu:orderSettingsPage.deliveryPrice")}:</span> <span> ₽ {deliveryConditions.fixedDeliveryPrice.price/100}</span><br/>
                                    <span>{t("menu:deliveryZones.freeDelivery")}</span> <span> ₽ {deliveryConditions.freeDeliveryMinimalOrderPrice.price/100}</span>
                                </>
                            }



                        </div>
                        <div className={[style.deliveryConditions, deliveryConditions.type === DeliveryConditionType.zonePrice ? style.selected : undefined].join(" ")}>
                        <FormControlLabel
                                checked={deliveryConditions.type === DeliveryConditionType.zonePrice}
                                key={DeliveryConditionType.zonePrice}
                                disabled={!authStore.isBasicFeaturesActive()}
                                control={<Radio/>}
                                label={
                                    <div className={style.deliveryLabel}>
                                        <svg stroke="blue" width="31" height="30" viewBox="0 0 31 30" xmlns="http://www.w3.org/2000/svg" fill="none">
                                            <path className={style.svg} d="M21.6471 3.89742H28.1831C29.1475 3.89742 29.9294 4.67926 29.9294 5.64366V27.62C29.9294 28.5844 29.1475 29.3662 28.1831 29.3662H2.74624C1.78185 29.3662 1 28.5844 1 27.62V5.64366C1 4.67926 1.78185 3.89742 2.74624 3.89742H14.6602" stroke="black" stroke-opacity="0.5" stroke-width="0.87312" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path className={style.svg} d="M26.477 29.3662L9.1881 12.0773L1.0083 20.2571" stroke="black" stroke-opacity="0.5" stroke-width="0.87312" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path className={style.svg} d="M1.0083 15.7549L6.93743 9.82576L1.51558 4.40386" stroke="black" stroke-opacity="0.5" stroke-width="0.87312" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path className={style.svg} d="M29.9291 9.23489L20.5151 18.9552L29.8109 28.251C29.8869 28.0551 29.9291 27.8423 29.9291 27.6195" stroke="black" stroke-opacity="0.5" stroke-width="0.87312" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path className={style.svg} d="M25.4434 9.23438L29.7399 4.85248" stroke="black" stroke-opacity="0.5" stroke-width="0.87312" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path className={style.svg} d="M5.45703 3.8975L18.1914 16.6318L23.7119 11.0016" stroke="black" stroke-opacity="0.5" stroke-width="0.87312" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path className={style.svg} d="M21.5888 3.86242C21.5888 6.60279 19.365 10.8203 18.1535 10.8203C16.8757 10.8203 14.7183 6.37124 14.7183 3.86242C14.7183 1.97002 16.2563 0.436003 18.1535 0.436003C20.0508 0.436003 21.5888 1.97002 21.5888 3.86242Z" stroke="black" stroke-opacity="0.5" stroke-width="0.87312" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path className={style.svg} d="M18.1537 2.35828C19.0383 2.35828 19.7556 3.07732 19.7556 3.9643C19.7556 4.85127 19.0383 5.57031 18.1537 5.57031C17.269 5.57031 16.5518 4.85127 16.5518 3.9643C16.5518 3.07732 17.269 2.35828 18.1537 2.35828Z" stroke="black" stroke-opacity="0.5" stroke-width="0.87312" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path className={style.svg} d="M10.7768 17.4495C10.3401 17.2489 9.85435 17.1362 9.342 17.1362C7.44477 17.1362 5.90674 18.6703 5.90674 20.5626C5.90674 23.0714 8.06416 27.5205 9.342 27.5205C10.5535 27.5205 12.7773 23.303 12.7773 20.5626C12.7773 20.0151 12.6479 19.4979 12.4189 19.0389" stroke="black" stroke-opacity="0.5" stroke-width="0.87312" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path className={style.svg} d="M9.34163 19.0575C10.2263 19.0575 10.9435 19.7765 10.9435 20.6635C10.9435 21.5505 10.2263 22.2695 9.34163 22.2695C8.45693 22.2695 7.73975 21.5505 7.73975 20.6635C7.73975 19.7765 8.45693 19.0575 9.34163 19.0575Z" stroke="black" stroke-opacity="0.5" stroke-width="0.87312" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <div>
                                            <p className={style.deliveryType}>{t("menu:zoned")}</p>
                                            <p className={style.deliveryTypeDescription}>{t("menu:differentCost")}</p>
                                        </div>
                                    </div>}

                                onChange={() => {
                                    const data: IDeliveryConditionsZonePrice = {
                                        type: DeliveryConditionType.zonePrice,
                                        deliveryZones: []
                                    };
                                    store.setDeliveryToAddressSettings({
                                        description: localize(store.deliverySettings[DeliveryType.toAddress].description),
                                        deliveryConditions: data,
                                        isEnabled: store.deliverySettings[DeliveryType.toAddress].isEnabled,
                                    })
                                }}
                        />

                            {(deliveryConditions && deliveryConditions.type === DeliveryConditionType.zonePrice) &&
                                <>
                                    {(store.deliveryZones[0] && store.deliveryZones[0].coordinates.length > 0) ?
                                        <>
                                            <div className={style.change}>
                                                <p className={style.zones}>{t("menu:deliveryZones.yourZones")}</p>
                                                <Button
                                                    onClick={openDeliveryZoneForm}
                                                    color="primary"
                                                    m={0}
                                                    p={0}
                                                    disabled={!authStore.isBasicFeaturesActive()}
                                                >
                                                    {t("general:change")}
                                                </Button>
                                            </div>

                                                { store.deliveryZones && store.deliveryZones.map((zone, index) => {
                                                    return (
                                                        <div>
                                                            <p className={style.zonesName}>{zone.name}</p>
                                                            <span> {t("menu:orderSettingsPage.deliveryPrice")}:</span><span> ₽ {zone.fixedDeliveryPrice?.price ? zone.fixedDeliveryPrice.price/100 : "не установлено"}</span> <br/>
                                                            <span>{t("menu:deliveryZones.freeDelivery")}</span><span> ₽ {zone.freeDeliveryMinimalOrderPrice?.price ? zone.freeDeliveryMinimalOrderPrice.price/100 : "не установлено"}</span>
                                                        </div>
                                                    )})}

                                        </>
                                        :
                                        <>
                                            <p className={style.zones}>{t("menu:deliveryZones.yourZones")}</p>
                                            <p className={style.noZones}>{t("menu:deliveryZones.noZones")} </p>
                                            <Button
                                                disabled={!authStore.isBasicFeaturesActive()}
                                                onClick={openDeliveryZoneForm}
                                                color="primary"
                                                variant="contained"
                                                m={0}
                                                mt={5}
                                                pt={3}
                                                pb={3}
                                                pl={5}
                                                pr={5}
                                            >
                                                {t("general:add")}
                                            </Button>
                                        </>
                                    }
                                </>

                            }

                        </div>

                    </RadioGroup>
                </FormControl>
            }

		</Paper>}

        {!hasIIkoIntegration && <Paper p={5} style={{ maxWidth: 800, width: "100%" }} mt={5}>
			<Typography variant="h6" mt={0}>
                {t("menu:orderSettingsPage.deliveryToCar")}
			</Typography>
			<Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:orderSettingsPage.suitableToCar")}
			</Typography>
			<FormControl>
				<FormControlLabel
					control={
                        <Switch
                            checked={store.deliverySettings[DeliveryType.toVehicle].isEnabled && authStore.isBasicFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isBasicFeaturesActive()) {
                                        store.openTariffPromptForm('Basic')
                                    } else {
                                        store.setDeliveryToVehicleSettings({
                                            description: localize(store.deliverySettings[DeliveryType.toVehicle].description),
                                            isEnabled: v,
                                        })
                                    }
                                }
                            )}
                            value={store.deliverySettings[DeliveryType.toVehicle].isEnabled}
                        />
                    }
					label={t("general:include")}
				/>
			</FormControl>
			<FormControl fullWidth>
				<InputLabel htmlFor="name">{t("general:description")}</InputLabel>
				<Input
					value={localize(store.deliverySettings[DeliveryType.toVehicle].description)}
					onChange={changeEventHandlerDecorator(
                        (v: string) => {
                            store.setDeliveryToVehicleSettings({
                                description: v,
                                isEnabled: store.deliverySettings[DeliveryType.toVehicle].isEnabled,
                            })
                        }
                    )}
					disabled={!store.deliverySettings[DeliveryType.toVehicle].isEnabled}
				/>
			</FormControl>
		</Paper>
        }
    </>

}


export default observer(DeliveryTypesBlock)
